import { useCallback, useEffect, useRef } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import type { RootState } from "~/store";
import { startTutorialTour, TUTORIAL_ACTIVE_FLAG } from "~/utils/tutorialEvents";

export const useTutorialAccessGuard = () => {
  const navigate = useNavigate();
  const { currentUser, organization } = useSelector(
    (state: RootState) => ({
      currentUser: state.auth.currentUser,
      organization: state.auth.organization,
    }),
    shallowEqual,
  );
  const organizationId = currentUser?.organization_id || organization?.id;
  const hasAttemptedStart = useRef(false);

  const redirectToHome = useCallback(() => {
    if (organizationId) {
      navigate(`/${organizationId}/home`, { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  }, [navigate, organizationId]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const isActive = localStorage.getItem(TUTORIAL_ACTIVE_FLAG) === "true";
    if (!isActive) {
      if (hasAttemptedStart.current) {
        redirectToHome();
        return;
      }
      hasAttemptedStart.current = true;

      startTutorialTour();
      navigate("/tutorial/project-top", { replace: true });
    }
  }, [navigate, redirectToHome]);
};
